import { Rule } from '@/_proto/quest_pb'

export default class AdventureType {
  rules: any

  constructor(data = <any>{}) {
    Object.keys(data).forEach(key => {
      if (key === 'rulesMap') {
        const map = new Map(data.rulesMap)
        this.rules = <any>{}
        this.rules.isHpRecoveryChangeParamRecovery = map.get(Rule.HP_RECOVERY_CHANGE_PARAM_RECOVERY)
        this.rules.isIntDamageChangeIntDebuff = map.get(Rule.INT_DAMAGE_CHANGE_INT_DEBUFF)
        this.rules.isNoSameHero = map.get(Rule.NO_SAME_HERO)
        this.rules.isNoSameRarity = map.get(Rule.NO_SAME_RARITY)
        this.rules.isNoWp = map.get(Rule.NO_WP)
        this.rules.isPrimeOnly = map.get(Rule.PRIME_ONLY)
        this.rules.isRegulation0619 = map.get(Rule.REGULATION_06_19)
        this.rules.isNoSameExtension = map.get(Rule.NO_SAME_EXTENSION)
        this.rules.isNeedPhonehash = map.get(Rule.NEED_PHONEHASH)
        this.rules.isMultipleEntry = map.get(Rule.MULTIPLE_ENTRY)
      }
      this[key] = data[key]
    })
  }
}
